import { useStyles } from './back-to-top-button.styles';
import arrowTopIcon from '../../../../../assets/images/icons/arrow/arrow-top.png';

type BackToTopButtonProps = {
  visible: boolean;
  onClick: () => void;
};

export const BackToTopButton = ({ visible, onClick }: BackToTopButtonProps) => {
  const classes = useStyles();

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={onClick}
      className={classes.backToTop}
    >
      <img src={arrowTopIcon} alt=''/>
    </button>
  );
};
